<mojo-contactus-widget [widget]="widget" [loading]="loading$ | async"  [contactInfo]="contactInfo$ | async"  ></mojo-contactus-widget>
